import { useParams } from "react-router-dom";
import { useLinksPromotion } from "./links-queries";
import styles from "./links.module.scss";
import { LinksDestinations } from "./links-destinations";

export function LinksSettings() {
    const { accountID, showID, promotionID } = useParams();
    const { data: promotion } = useLinksPromotion(
        accountID,
        showID,
        promotionID
    );

    return (
        <>
            <h2>Custom Landing Page for Your Show</h2>
            <p>Click here to check out your custom landing page for your show:</p>

            <div className={styles.section}>
            {promotion?.placements?.map(p => {
                const url = p.linkUrl;
                const displayUrl = `https://link.podtrac.com/${ p.alias }`;
                return <p key={p.alias} style={{margin: "0.5rem 0"}}>
                    <b>
                        <a href={url} target="_blank">
                            {displayUrl}
                        </a>
                    </b>
                </p>;
            })}
            </div>
            

            <h2>Podcast App Platforms</h2>
            <p>Here are the podcast app platforms linked on the page. You may deselect any you would like leave off the page:</p>

            <LinksDestinations />

            <h2>Next Steps</h2>

            <p><b>Post Your Smartlink</b></p>
            <p>Post your Promo Link to social media, newsletters, emails, other websites, show or episode descriptions, anywhere online.</p>

            <p><b>View Results</b></p>
            <p>Come back to this page to view results:  Here are the metrics you will see on your reports page:</p>

            <div className={styles.section}>
            <dl className={styles.metrics}>
                <dt>Clicks</dt>
                <dd>Number of times the link has been clicked.</dd>
                <dt>Downloads</dt>
                <dd>Number of episodes of the promoted show downloaded by anyone who clicked the trackable link. (This includes new and existing listeners of the promoted show.)</dd>
                <dt>Download (Conversion) Rate</dt>
                <dd>Downloads / Clicks</dd>
                <dt>New Downloads</dt>
                <dd>Number of episodes of the promoted show downloaded by new listeners who clicked the trackable link.</dd>
                <dt>New Download (Conversion) Rate</dt>
                <dd>New Downloads / Clicks</dd>
            </dl>
            </div>

            <p>Note: For large podcasts and networks, Podtrac offers an Audio Promo + Smartlink service with additional features. To schedule a demo of this service, email support@podtrac.com.</p>
            {/*<pre>{JSON.stringify(promotion, null, 2)}</pre>*/}
        </>
    );
}
